import { FetchBaseQueryError, FetchBaseQueryMeta } from "@reduxjs/toolkit/dist/query";
import { ZodSchema } from "zod";
import { z } from "zod";
import { errorResponseSchema } from "../../models/errors/errorResponse";
import log from "loglevel";
import { QueryReturnValue } from "../../models/baseQueries/baseQueryTypes";

export const serveResult = <T>(result: QueryReturnValue<unknown, FetchBaseQueryError, FetchBaseQueryMeta>) => {
  if (result.error) {
    return { error: result.error as FetchBaseQueryError, meta: result.meta };
  }
  return { data: result.data as T, meta: result.meta };
};

export const validateError = (
  result: QueryReturnValue<unknown, FetchBaseQueryError, FetchBaseQueryMeta>,
  schema?: ZodSchema
) => {
  const { error } = result;
  try {
    if (error) {
      if (schema) {
        z.object({
          status: z.number(),
          data: schema,
        }).parse(error);
      } else {
        errorResponseSchema.parse(error);
      }
    }
  } catch (error) {
    if (error instanceof z.ZodError) {
      log.error("Model structure validation failed: ", error.format());
    }
  }
};

export const validateResult = (
  result: QueryReturnValue<unknown, FetchBaseQueryError, FetchBaseQueryMeta>,
  schema: ZodSchema
) => {
  const { data } = result;
  if (data) {
    schema.parse(data);
  }
};